<div>
  <ng-container *ngFor="let alert of sessionQuery.getValue().alerts; let index = index">
    <div class="mb-5 mb-xl-10 position-relative" *ngIf="!isClosed(index)">
          <span [inlineSVG]="'./assets/media/icons/duotune/arrows/arr011.svg'"
                style="right: -1rem; top:-1rem; cursor: pointer"
                *ngIf="alert.severity !== 'danger'"
                (click)="close(index)"
                class="svg-icon svg-icon-1  position-absolute z-index-1 p-2 bg-white rounded-circle shadow-sm border border-2"
                [ngClass]="{
      'text-hover-danger' : alert.severity === 'danger',
      'text-hover-warning' : alert.severity === 'warning',
      'text-hover-primary' : alert.severity === 'info'}"></span>
      <div class="card p-8 border border-2" [ngClass]="{
      'border-danger' : alert.severity === 'danger',
      'border-warning' : alert.severity === 'warning',
      'border-primary' : alert.severity === 'info'}">
        <div class="card-body d-flex p-0 ">
          <div class="d-flex h-80px w-80px flex-shrink-0 flex-center position-relative"
               *ngIf="alert.severity === 'danger'">
          <span class="svg-icon svg-icon-danger position-absolute opacity-15"
                [inlineSVG]="'./assets/media/icons/duotune/abstract/abs051.svg'"
                [setSVGAttributes]="{ class: 'h-80px w-80px' }"></span>
            <span [inlineSVG]="'./assets/media/icons/duotune/coding/cod014.svg'"
                  class="svg-icon svg-icon-5tx svg-icon-danger position-absolute"></span>
          </div>
          <div class="d-flex h-80px w-80px flex-shrink-0 flex-center position-relative"
               *ngIf="alert.severity === 'warning'">
          <span class="svg-icon svg-icon-warning position-absolute opacity-15"
                [inlineSVG]="'./assets/media/icons/duotune/abstract/abs051.svg'"
                [setSVGAttributes]="{ class: 'h-80px w-80px' }"></span>
            <span [inlineSVG]="'./assets/media/icons/duotune/coding/cod011.svg'"
                  class="svg-icon svg-icon-3tx svg-icon-warning position-absolute"></span>
          </div>
          <div class="d-flex h-80px w-80px flex-shrink-0 flex-center position-relative"
               *ngIf="alert.severity === 'info'">
          <span class="svg-icon svg-icon-primary position-absolute opacity-15"
                [inlineSVG]="'./assets/media/icons/duotune/abstract/abs051.svg'"
                [setSVGAttributes]="{ class: 'h-80px w-80px' }"></span>
            <span [inlineSVG]="'./assets/media/icons/duotune/communication/com003.svg'"
                  class="svg-icon svg-icon-2tx svg-icon-primary position-absolute"></span>
          </div>
          <div class="ms-6">
            <span class="fw-bolder fs-2 mb-0" [innerHTML]="alert.title"></span>
            <div class="fs-6 mb-0" [innerHTML]="alert.message"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</div>

<router-outlet></router-outlet>
